import { HideInfobarDetailsButton } from 'owa-locstrings/lib/strings/hideinfobardetailsbutton.locstring.json';
import { ShowInfobarDetailsButton } from 'owa-locstrings/lib/strings/showinfobardetailsbutton.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import PolicyTipsViewState from '../store/schema/PolicyTipsViewState';
import { InfoBarShowDetailsAction } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { PolicyTipsDetails } from '../components/PolicyTipsDetails';

export function createPolicyTipsShowDetailsInfoBarAction(
    policyTipsViewState: PolicyTipsViewState,
    getRecipientByEmailAddress: (emailAddress: string) => EmailAddressWrapper,
    onRecipientRemoveClick: (recipients: EmailAddressWrapper[]) => void
): InfoBarShowDetailsAction {
    return {
        showDetailsText: loc(ShowInfobarDetailsButton),
        hideDetailsText: loc(HideInfobarDetailsButton),
        detailsElement: (
            <PolicyTipsDetails
                viewState={policyTipsViewState}
                getRecipientByEmailAddress={getRecipientByEmailAddress}
                onRecipientRemoveClick={onRecipientRemoveClick}
            />
        ),
    };
}
